/* =============================================================
   JMM Marques — tilt 3D au pointeur (relaie le flottement ambiant,
   puis le lui rend). Désactivé sans pointeur fin ou en motion réduite.
   ============================================================= */
(function () {
  'use strict';

  function initJmq(root) {
    if (root.hasAttribute('data-jmq-init')) return;
    root.setAttribute('data-jmq-init', '1');

    var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!finePointer || reduce || root.getAttribute('data-jmq-tilt') === 'false') return;

    root.querySelectorAll('.jmq__card').forEach(function (card) {
      card.addEventListener('pointermove', function (e) {
        card.classList.add('is-live');
        var r = card.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width;
        var py = (e.clientY - r.top) / r.height;
        card.style.transform = 'rotateX(' + ((py - .5) * -9) + 'deg) rotateY(' + ((px - .5) * 11) + 'deg) translateZ(3px)';
        card.style.setProperty('--gx', (px * 100) + '%');
        card.style.setProperty('--gy', (py * 100) + '%');
      });
      card.addEventListener('pointerleave', function () {
        card.style.transition = 'transform .6s cubic-bezier(.22,1,.36,1)';
        card.style.transform = '';
        window.setTimeout(function () {
          card.classList.remove('is-live');
          card.style.transition = '';
          card.style.removeProperty('--gx');
          card.style.removeProperty('--gy');
        }, 620);
      });
    });
  }

  function initAll() { document.querySelectorAll('.jmq').forEach(initJmq); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else { initAll(); }
  document.addEventListener('shopify:section:load', function () { window.setTimeout(initAll, 0); });
})();
